import React from 'react';
import { handleError } from 'src/utils/errors/common';
import { Button } from '@mui/material';
import { register } from 'src/utils/contracts/registrar';
import useStore from 'src/store/cns';
import { insertNode } from 'src/utils/data/domains';
import { namehash } from 'ethers';

const Registration: React.FC<{
  setRegisterState: (state: RegisterState) => void;
  domainName: string;
  registrationPeriod: number;
  tokenAddress: string;
  registrationCost: number;
  walletAddress: string;
}> = ({
  setRegisterState,
  domainName,
  registrationPeriod,
  tokenAddress,
  registrationCost,
  walletAddress,
}) => {
  const firstLvlDomains = useStore(state => state.firstLvlDomains);
  const setFirstLvlDomains = useStore(state => state.setFirstLvlDomains);

  const registerDomain = async () => {
    try {
      await register(
        domainName,
        registrationPeriod,
        tokenAddress,
        registrationCost,
      );

      setRegisterState({
        domainName: domainName,
        status: 'success',
      });
      insertNode({
        name: domainName + '.cam',
        owner: walletAddress,
        parentHash:
          '0xae699f70ed198095f47e32ff39f1f2a31565a531bc8a8f2dd472afdffe7a1a9d',
        hash: namehash(domainName + '.cam'),
        subdomains: [],
      });
      const newFistLvlDomains = firstLvlDomains;
      newFistLvlDomains.push(domainName);
      setFirstLvlDomains(newFistLvlDomains);
    } catch (error) {
      handleError(error, `Contract call failed.`);
    }
  };

  return (
    <Button
      variant="contained"
      onClick={() => registerDomain()}
      sx={{
        color: 'text.primary',
        backgroundColor: 'primary.main',
        padding: '10px 16px',
      }}
    >
      Register
    </Button>
  );
};

export default React.memo(Registration);
